import styled from 'styled-components'
import { smallMobile, desktop, mobile, tablet } from '../../common/utils/screenStyles'
import { StyledParagraph } from '../../common/styledComponents/StyledText'

export const StyledWrapper = styled.div`
  height: 100%;
  max-height: 100%;
  width: 100vw;
  position: relative;
  background: linear-gradient(121.52deg, #F4F6F9 4.18%, #DBE3EC 100%);
  padding: 5.5% 10.20%;
  display: flex;
  align-items: center;
  &.switch-container label.active {
    background-color: blue;
  }
  & .submit-btn {
    margin-top: 10px;
    padding: unset;
    height: 36px;
  }

  & .invite {
    margin-top: 0;
    height: 36px;
    width: 100%;
    padding: unset;

    ${mobile`
      min-width: 100px;
    `}
  }

  & .skip-btn {
    height: 36px;
    width: 100%;
    padding: unset;

    ${mobile`
      min-width: 100px;
    `}
  }

  & .form-input {
    width: 100%;
    max-width: 400px;
    margin-bottom: 1.2em;
    margin-top: 0;

    ${tablet`
      width: 90%;
    `}

    ${mobile`
      width: 100%;
      max-width: unset;
      min-height: 60px;
    `}

    & input {
      ${mobile`
        position: absolute;
        bottom: 0;
        left: 0;
      `}
    }
  }

  & .form-input.login-email {
    margin-bottom: 35px;
  }

  & .email{
    margin-top: 35px;
    margin-bottom: 35px;
  }

  ${tablet`
    padding: 5.5% 5%;
  `}

  ${mobile`
    padding: 0;
  `}
`

export const StyledPanelInfoSection = styled.div`
  position: relative;
  width: 100%;
  margin: 0;
  height: 100%;
  padding: 0 30px;
  padding-top: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  & h2.heading {
    text-transform: uppercase;
  }
  ${mobile`
    padding-right: 7.22%;
    padding-left: 7.22%;
    padding-top: 20px;
  `}

  ${tablet`
    padding: 0 28px;
    padding-top: 30%;
  `}

  & h1.heading {
    ${desktop`
      margin: 0 30px;
    `}

    ${tablet`
      font-size: 24px;
      line-height: 32px;
      margin: 0 13px;
    `}

    ${mobile`
      font-size: 24px;
      line-height: 32px;
    `}
  }

  & h3.heading3 {
    ${mobile`
      font-family: Lato;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.25px;
    `}
  }

  & .field-setup-text {
    font-weight: 600;
    ${mobile`
      font-weight: unset;
    `}

  }
`

export const StyledForm = styled.form`
  width: 100%;
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8.5% 40px;
  z-index: 2;
  &.switch-container label.active {
    background-color: red;
  }
  & .form-info {
    margin-top: 14px;
    width: 246px;
    text-align: center;
    ${mobile`
      width: 80%;
    `}
  }

  & .form-info.invite {
    width: 100%;
    margin-top: 0;
    height: unset;

    ${mobile`
      width: unset;
    `}
  }

  & .heading {
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 24px;
    text-align: center;
  }

  & heading3 {
    margin-bottom: 24px;
    text-align: center;
  }

  ${tablet`
    min-height: 80vh;
    padding: 8.5% 30px;
  `}

  ${mobile`
    padding: 30px 7.22%;
    min-height: 80vh;
    justify-content: flex-start;
  `}
`

export const Logo = styled.img`
  width: 200px;
  height: auto;
  margin-bottom: 89px;
  ${mobile`
    height: 32px;
    width:  132px;
    margin-bottom: 24px;
  `}
`

export const SplitRowDiv = styled.div`
  display: grid;
  width: 100%;
  max-width: 400px;
  grid-template-columns: 1fr 1fr;
  justify-self: start;
  grid-column-gap: 16px;
  margin-top: 35px;
  & .register {
    min-height: 70px;
    & input {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  &.split-div-content {
    margin-bottom: 1em;
    margin-top: 0;
    & .split-item {
      min-height: 63px;
      & input {
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    & .access_type {
      min-height: 63px;
      border-bottom: 1px ${props => props.theme.colors.gray} solid;
      & label {
        margin-bottom: 0;
      }

      & .dropdown_class {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
      }
    }
  }
  & input {
    max-width: 192px;
    width: 45%;
    ${tablet`
      width: 40%;
    `}

    ${mobile`
      min-width: 100%;
    `}
  }

  &.invite-buttons {
    ${mobile`
      width: 100%;
      grid-template-rows: auto;
      grid-template-columns: 1fr 1fr;
      align-self: center;
      grid-column-gap: 20px;
      grid-row-gap: unset;
    `}
  }

  ${tablet`
    width: 90%;
  `}

  ${mobile`
    width: 100%;
    max-width: unset;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: auto;
    align-self: start;
    grid-column-gap: 0;
    grid-row-gap: 43px;
    margin-top: 27px;
  `}
`

export const StyledPanelBottomText = styled(StyledParagraph)`
  position: absolute;
  bottom: 120px;
  @media screen and (max-height: 400px) {
    position: unset;
    bottom: unset;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  ${mobile`
    display: none;
    position: unset;
    bottom: unset;
    margin: unset;
  `}

  &.mobile {
    display: none;

    ${mobile`
      display: block;
      margin-top: 30px;
    `}
  }
`

export const StyledVerifyEmailContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 75vh;
  height: 100%;
  padding: 0 15%;
  padding-bottom: 120px;
  ${mobile`
    padding: 24px 7.22%;
  `}
`

export const StyledFieldSetupInfoContainer = styled.div`
  min-width: 100%;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8.5% 20px;
  & .heading.field {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    ${mobile`
      text-align: center;
    `}

    ${smallMobile`
      text-align: center;
    `}
  }

  & .submit-btn {
    margin-top: 20px;
  }

  ${mobile`
    padding: 20px;
  `}
`

export const StyledFieldSetupIconsContainer = styled.div`
  width: 80%;
  max-width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  flex-grow: 1;
  overflow-y: auto;
  ${mobile`
    width: 100%;
    max-width: 100%;
  `}
`

export const StyledFieldSetupIconsSubContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 64px;
  ${mobile`
    flex-direction: column;
    justify-content: flex-start;
  `}
`

export const StyledFieldSetupTextContent = styled.div`
  width: 80%;
  margin-left: 25px;
  text-align: left;
  & .heading {
    text-align: left;
    ${mobile`
      text-align: center;
    `}
  }

  ${mobile`
    margin-left: 0;
    text-align: center;
    margin-top: 16px;
  `}
`

export const StyledImageBottom = styled.img`
  position: absolute;
  width: 90%;
  height: 220px;
  bottom: 0;
  right: 0;
  ${mobile`
    height: 130px;
    width: 100%;
  `}

  ${tablet`
    width: 70%;
    height: 180px;
  `}
`

export const StyledDiv = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
`

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100px;
`
